import { ChevronDownIcon, ChevronRightIcon } from "@storytell/bsky-icons";
import { clsx } from "clsx";
import { type JSX, Show } from "solid-js";
import { twMerge } from "tailwind-merge";
import { GradientBorder } from "~/components/prompt/internal/components";
import { ProcessingSpinner } from "~/components/ui";

interface BlockHeaderPillProps {
  title: string;
  icon: JSX.Element;
  isProcessing: boolean;
  onClick: () => void;
  onCopyDebugInfo: (e: MouseEvent) => void;
  variant?: "blue" | "purple";
  hasExpandableContent?: boolean;
  isExpanded?: boolean;
}

export const BlockHeaderPill = (props: BlockHeaderPillProps) => {
  const variant = () => props.variant || "blue";

  const getVariantClasses = () => {
    switch (variant()) {
      default:
        return {
          pill: "bg-panel hover:bg-panel-hover text-primary-text border border-muted-border",
          spinner: "border-secondary-text border-2",
        };
    }
  };

  return (
    <div class="flex items-center gap-2 relative">
      {/* <Show when={props.isProcessing}>
        <GradientBorder inset={-2} blur={4} />
      </Show> */}
      <button
        type="button"
        onClick={props.onClick}
        class={twMerge(
          "inline-flex items-center gap-2 py-2 px-3 rounded-full text-xs font-medium transition-all",
          getVariantClasses().pill,
          props.isProcessing && "animate-pulse",
        )}
        title={`Click to view: ${props.title}`}
      >
        <span class="text-brand opacity-70">{props.icon}</span>
        <span class="whitespace-nowrap">{props.title}</span>
        <Show when={props.isProcessing}>
          <ProcessingSpinner class="w-3 h-3 border-[1.5px] border-secondary-text" />
        </Show>
        <Show when={props.hasExpandableContent}>
          <ChevronDownIcon
            size={12}
            class="stroke-3 text-secondary-text transition-transform duration-100"
            classList={{
              "-rotate-90": !props.isExpanded,
            }}
          />
        </Show>
      </button>
    </div>
  );
};
